/*
 * @file Provide Folder Mixins
 */
export const MAX_FOLDER_NAME_LENGTH = 128

interface FolderForSelector {
  id: number
  name: string
  disabled: boolean
  message: string | null
}

export function maxFolderNameLength(): number {
  return MAX_FOLDER_NAME_LENGTH
}

export function isValidFolderName(folderName: string | null): boolean {
  if (!folderName) return false
  const trimmedLength: number = folderName.trim().length
  return trimmedLength > 0 && trimmedLength <= MAX_FOLDER_NAME_LENGTH
}

export function folderForSelector(
  folder: { id: number; name: string },
  options?: { disabled?: boolean; message?: string },
): FolderForSelector {
  return {
    id: folder.id,
    name: folder.name,
    disabled: options?.disabled || false,
    message: options?.message || null,
  }
}
